<h2 mat-dialog-title class="flex items-center justify-between m-0">
    <span>
        Pending Tasks
        <span *ngIf="inwards?.length"
              class="ml-2 inline-flex items-center justify-center text-xs font-semibold px-2 py-0.5 rounded-full bg-primary-100 text-primary-800">
            {{ inwards.length }}
        </span>
    </span>
    <button mat-icon-button [mat-dialog-close]="false" aria-label="Close">
        <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
    </button>
</h2>

<mat-dialog-content class="assign-task-content">
    <table class="assign-task-table w-full text-sm text-left border-collapse">
        <thead>
            <tr class="bg-gray-50 dark:bg-gray-800 text-gray-700 dark:text-gray-200">
                <th class="px-4 py-3 font-semibold whitespace-nowrap">Job Number</th>
                <th class="px-4 py-3 font-semibold whitespace-nowrap">Job Date</th>
                <th class="px-4 py-3 font-semibold whitespace-nowrap">Bank Name</th>
                <th class="px-4 py-3 font-semibold whitespace-nowrap">Branch Name</th>
                <th class="px-4 py-3 font-semibold whitespace-nowrap">Status Name</th>
                <th class="px-4 py-3 font-semibold">Notes</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let inward of inwards; trackBy: trackByFn"
                class="border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/50">
                <td class="px-4 py-3">
                    <span (click)="openReport(inward)"
                          class="inline-flex items-center justify-center font-bold text-xs px-2.5 py-1 rounded-full tracking-wide uppercase cursor-pointer"
                          [ngClass]="{
                              'text-green-800 bg-green-200 dark:text-green-50 dark:bg-green-500': inward.dueDate && !isOverdue(inward.dueDate),
                              'text-red-800 bg-red-200 dark:text-red-50 dark:bg-red-500': inward.dueDate && isOverdue(inward.dueDate),
                              'celebration': inward.isFinalizeReport
                          }">{{ inward.jobNumber }}</span>
                </td>
                <td class="px-4 py-3 whitespace-nowrap">{{ inward.inwardDate | date:'dd/MM/yyyy' }}</td>
                <td class="px-4 py-3">{{ inward.bankName }}</td>
                <td class="px-4 py-3">{{ inward.bankBranchName }}</td>
                <td class="px-4 py-3 whitespace-nowrap">{{ inward.inwardStatus }}</td>
                <td class="px-4 py-3 text-gray-600 dark:text-gray-300">{{ inward.note }}</td>
            </tr>

            <tr *ngIf="!inwards?.length">
                <td colspan="6" class="px-4 py-10 text-center text-gray-500">
                    No pending tasks 🎉
                </td>
            </tr>
        </tbody>
    </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-flat-button color="primary" [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>
